/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import Cookies from 'js-cookie'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    flickrData: null,
    menuBtnInHeader: false,
    numberOfPhoto: 6,
    siteAccess: true
  },
  plugins: [createPersistedState({
    paths: ['siteAccess'],
    storage: {
      getItem: key => Cookies.get(key),
      setItem: (key, value) => Cookies.set(key, value, { expires: 3, secure: true }),
      removeItem: key => Cookies.remove(key)
    }
  })],
  mutations: {
    inHeader (state) {
      state.menuBtnInHeader = true
    },
    outHeader (state) {
      state.menuBtnInHeader = false
    },
    loadFlickrData (state, data) {
      state.flickrData = data
    },
    loadMorePhoto (state, number) {
      state.numberOfPhoto += number
    },
    accessGrant (state) {
      state.siteAccess = true
    }
  }
})

export default store




// WEBPACK FOOTER //
// ./src/vuex/store.js